module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/07cde53e4081efae25eaa9518ddc0f32.png";